import { faPencilAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { B2Button } from "@hdb/biome-2";
import { useQuery } from "@tanstack/react-query";
import { createRef, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import resetBtn from "../../../../../../assets/images/arrow-repeat.png";
import circleCheck from "../../../../../../assets/images/circle-check.png";
import circleCross from "../../../../../../assets/images/circle-cross.png";
import { getGatewayGroup } from "../../../../../../core/api/services/asset/gateway-group.service";
import { getDimmingProfile } from "../../../../../../core/api/services/asset/light-profile/dimming-profile.service";
import MfaComponent from "../../../../../../core/components/mfa/mfa.component";
import ModalComponent from "../../../../../../core/components/modal/modal.component";
import TableComponent from "../../../../../../core/components/table/table.component";
import { AssetCommandEnums } from "../../../../../../core/enums/assetCommands-enums";
import HasPermission from "../../../../../../core/guards/has-permission";
import FormBuilderComponent, {
  FormConfig,
} from "../../../../../../shared/form-builder/form-builder.component";
import { safeAtob } from "../../../../../../shared/helpers/enode-decode-string";
import TableSort from "../../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../../shared/helpers/upper-case";
import {
  deleteDimmingProfile,
  enableOrDisableDimmingProfile,
  getDaysOfWeek,
  getDimmingProfileByCode,
  postDimmingProfile,
  resetDimmingProfile,
  sendGetCommandToDms,
  updateDimmingProfile,
} from "../../../../../../store/slices/asset.slice";
import { setOtpIsValidation } from "../../../../../../store/slices/mfa-otp.slice";

import * as _ from "lodash";
import { Helmet } from "react-helmet-async";
import { getUserInfo } from "src/core/auth/auth.service";
import { toast } from "react-toastify";
import { displayToast } from "src/shared/helpers/toaster.helper";

const DimmingProfileComponent = () => {
  const dispatch = useDispatch();
  const params: any = useParams();
  const id = params.id ? safeAtob(params.id) : null;
  const formRef = createRef();
  const repeatActionFormRef = createRef();
  const [PageNumber, setPageNum] = useState<number>(1);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [groupOptions, setGroupOptions] = useState<any>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isDetails, setIsDetails] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [isEnableProfile, setIsEnableProfile] = useState<boolean | null>(null);
  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("profileName"));
  const [SortDirection, setSortDirection] = useState<any>("desc");
  // const [currentFeature, setCurrentFeature] = useState("" as any);
  const [isOTPModalOpen, setIsOtpModalOpen] = useState<boolean>(false);
  const [isRefreshing, setIsRefreshing] = useState<boolean>(false);
  const [chartDataLoaded, setChartDataLoaded] = useState<boolean>(false);
  const user = getUserInfo();

  const [selectedIdToDeleteOrEdit, setSelectedIdToDeleteOrEdit] =
    useState<number>(0);
  const [initialValues, setInitialValues] = useState<any>({
    profileName: "",
    startTime: "",
    endTime: "",
    zoneID: "",
    dimLevel: "",
    brightLevel: "",
    dayOfWeek: "",
  });

  const socketData = useSelector((state: any) => {
    return state.asset.socketData;
  });

  const socketRealTimeUpdate = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdate;
  });

  const socketRealTimeUpdateData = useSelector((state: any) => {
    return state.asset.socketRealTimeUpdateData;
  });

  const mfaInfo = useSelector((state: any) => {
    return state.user.mfaInfo;
  });

  const [repeatActionInitialValues, setRepeatActionInitialValues] =
    useState<any>({
      repeatAction: 30,
    });

  const [isRepeatActionModalOpen, setIsRepeatActionModalOpen] =
    useState<boolean>(false);

  const [multipleSeriesData, setMultipleSeriesData] = useState<any>([]);

  useEffect(() => {
    dispatch({
      type: "table/toggleSelectAll",
      payload: [],
    });

    dispatch(getDaysOfWeek());
  }, [dispatch]);

  const dimmingProfile = useSelector((state: any) => {
    return state.asset.dimmingProfileDetails;
  });

  useEffect(() => {
    if (dimmingProfile && Object.keys(dimmingProfile).length > 0) {
      const data = {
        profileName: dimmingProfile?.profileName || null,
        startTime: dimmingProfile?.startTime || null,
        endTime: dimmingProfile?.endTime || null,
        zoneID: dimmingProfile?.zoneId || 0,
        dimLevel: dimmingProfile?.dimLevel || 0,
        brightLevel: dimmingProfile?.brightLevel || 0,
        dayOfWeek: dimmingProfile?.dayOfWeek || null,
      };

      setInitialValues(data);
    }
  }, [dimmingProfile]);

  const daysOfWeek = useSelector((state: any) => {
    return state.asset.daysOfWeek;
  });

  const [daysOfWeekOptions, setDaysOfWeekOptions] = useState<any>([]);

  useEffect(() => {
    const days = daysOfWeek?.map((day: any) => ({
      value: day?.id,
      label: day?.name,
    }));

    setDaysOfWeekOptions(days);
  }, [daysOfWeek]);

  const pageSize = 10;

  /*   const lightProfileSocketData = useSelector((state: any) => {
    return state.asset.lightProfileSocketData;
  }); */

  const {
    data: dimmingProfiles,
    isLoading: isLoadingDimmingProfiles,
    refetch: refetchDimmingProfile,
  } = useQuery({
    queryKey: [
      "getDimmingProfile",
      pageSize,
      PageNumber,
      SortBy,
      SortDirection,
      id,
    ],
    queryFn: () =>
      getDimmingProfile(pageSize, PageNumber, SortBy, SortDirection, id),
    // enabled: onRefetchEnabled
  });

  const showToaster = (socketRealTimeUpdateData: any) => {
    if (
      user[
      "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
      ] === socketData?.NotificationIdentifier
    ) {
      displayToast(
        socketRealTimeUpdateData?.PushMessage || "Acknowledgement Received",
        socketRealTimeUpdateData?.ToasterColor
      );
    }
  };

  useEffect(() => {
    const copiedSocketRealTimeUpdate = _.cloneDeep(socketRealTimeUpdate);

    if (copiedSocketRealTimeUpdate.DimmingProfile) {
      showToaster(socketRealTimeUpdateData);
      refetchDimmingProfile();
      // setOnRefetchEnabled(true);
    }
  }, [socketRealTimeUpdate]); // socketRealTimeUpdateData

  const { data: gatewayGroups } = useQuery({
    queryKey: ["getGatewayGroup", id],
    queryFn: () => getGatewayGroup(id!),
    enabled: isModalOpen,
  });

  const convertToDecimalTime = (time: string) => {
    const splitTime = time.split(":");
    const hours = Number.parseInt(splitTime[0]);
    const minutes = Number.parseInt(splitTime[1]);
    // return hours + minutes / 60;
    const decimalTime = hours + minutes / 60;
    return Number.parseFloat(decimalTime.toFixed(2));
  };

  const generateData = (startTime: any, endTime: any, level: any) => {
    const data = [];

    const startHour = Number.parseInt(startTime.split(":")[0]);
    const endHour = Number.parseInt(endTime.split(":")[0]);

    const startMinute = Number.parseInt(startTime.split(":")[1]);
    const endMinute = Number.parseInt(endTime.split(":")[1]);

    // Case when start time is greater than end time (spanning across midnight)
    if (
      startHour > endHour ||
      (startHour === endHour && startMinute > endMinute)
    ) {
      // Generate data for the first range: start time to 23:59
      for (let hour = startHour; hour <= 23; hour++) {
        let startMin = 0;
        let endMin = 59;

        if (hour === startHour) {
          startMin = startMinute;
        }

        for (let minute = startMin; minute <= endMin; minute++) {
          const time = `${hour.toString().padStart(2, "0")}:${minute
            .toString()
            .padStart(2, "0")}`;
          const item = {
            time: convertToDecimalTime(time),
            value: level,
          };
          data.push(item);
        }
      }

      // Generate data for the second range: 00:00 to end time
      for (let hour = 0; hour <= endHour; hour++) {
        let endMin = 59;

        if (hour === endHour) {
          endMin = endMinute;
        }

        for (let minute = 0; minute <= endMin; minute++) {
          const time = `${hour.toString().padStart(2, "0")}:${minute
            .toString()
            .padStart(2, "0")}`;
          const item = {
            time: convertToDecimalTime(time),
            value: level,
          };
          data.push(item);
        }
      }
    } else {
      // Handle the usual case when start time is less than end time
      for (let hour = startHour; hour <= endHour; hour++) {
        let startMin = 0;
        let endMin = 59;

        if (hour === startHour) {
          startMin = startMinute;
        }
        if (hour === endHour) {
          endMin = endMinute;
        }

        for (let minute = startMin; minute <= endMin; minute++) {
          const time = `${hour.toString().padStart(2, "0")}:${minute
            .toString()
            .padStart(2, "0")}`;
          const item = {
            time: convertToDecimalTime(time),
            value: level,
          };
          data.push(item);
        }
      }
    }

    return data;
  };

  useEffect(() => {
    if (dimmingProfiles?.data?.length) {
      const enabledDimmingData = dimmingProfiles.data.filter(
        (x: any) => x.status.toLowerCase() === "enabled"
      );
      let dimLevelSeries: any = [];
      let brightLevelSeries: any = [];

      for (let item of enabledDimmingData) {
        const timeSplit = item.startTime.split("-");
        const startTime = timeSplit[0];
        const endTime = timeSplit[1];

        const dimLevelData = generateData(startTime, endTime, item.dimLevel);

        for (let item of dimLevelData) {
          dimLevelSeries.push(item);
        }

        const brightLevelData = generateData(
          startTime,
          endTime,
          item.brightLevel
        );

        for (let item of brightLevelData) {
          brightLevelSeries.push(item);
        }
      }

      var dimmingSeriesData = [];

      // Format the data for Highcharts
      for (var i = 0; i < dimLevelSeries.length; i++) {
        dimmingSeriesData.push([
          dimLevelSeries[i].time,
          dimLevelSeries[i].value,
        ]);
      }

      var brightSeriesData = [];

      // Format the data for Highcharts
      for (var i = 0; i < brightLevelSeries.length; i++) {
        brightSeriesData.push([
          brightLevelSeries[i].time,
          brightLevelSeries[i].value,
        ]);
      }

      if (dimmingSeriesData?.length && brightSeriesData?.length) {
        setMultipleSeriesData([
          { data: dimmingSeriesData, name: "Dim Level" },
          { data: brightSeriesData, name: "Bright Level" },
        ]);
      }
    } else {
      setMultipleSeriesData([]);
    }
  }, [dimmingProfiles]);

  useEffect(() => {
    // if(!multipleSeriesData?.length) return;
    setChartDataLoaded(true);
  }, [multipleSeriesData]);

  useEffect(() => {
    const groups = gatewayGroups?.data?.map((group: any) => ({
      value: group?.zoneId,
      label: group?.groupName + ` (Zone - ${group?.zoneId})`,
    }));

    setGroupOptions(groups);
  }, [gatewayGroups]);

  /*   useEffect(() => {
    if (lightProfileSocketData?.Type == NotificationTypeEnum.DIMMING_PROFILE) {
      refetchDimmingProfile();
    }
  }, [lightProfileSocketData]); */

  const formConfig: FormConfig = {
    controls: [
      {
        name: "profileName",
        label: "Profile Name",
        placeholder: "Profile Name",
        type: "text",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "startTime",
        label: "Start Time",
        placeholder: "Start Time",
        type: "time",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "endTime",
        label: "End Time",
        placeholder: "End Time",
        type: "time",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "zoneID",
        label: "Group",
        placeholder: "Select Group",
        type: "select",
        options: groupOptions,
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "dimLevel",
        label: "Dim Level (%)",
        placeholder: "e.g: 12",
        type: "text",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "brightLevel",
        label: "Bright Level (%)",
        placeholder: "e.g: 80",
        type: "text",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
      {
        name: "dayOfWeek",
        label: "Days Of Week",
        placeholder: "Select Days Of Week",
        type: "select",
        options: daysOfWeekOptions,
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
    ],
  };

  const repeatActionFormConfig: FormConfig = {
    controls: [
      {
        name: "repeatAction",
        label: "Repeat Action",
        placeholder: "Repeat Action",
        type: "number",
        required: true,
        readOnly: isDetails,
        disabled: isDetails,
      },
    ],
  };

  const selectedItems = useSelector((state: any) => state.table.selectedItems);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsEdit(false);
    setIsDetails(false);
    setIsDelete(false);
    setIsOtpModalOpen(false);
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  const onSubmit = () => {
    const form: any = formRef.current;
    if (form) {
      form.handleSubmit();

      const {
        profileName,
        startTime,
        endTime,
        zoneID,
        dimLevel,
        dayOfWeek,
        brightLevel,
      } = form.values;

      const trimmedProfileName = profileName.trim();

      if (
        !trimmedProfileName ||
        trimmedProfileName?.length > 50 ||
        !startTime ||
        !endTime ||
        !zoneID ||
        !dimLevel ||
        dimLevel?.length > 50 ||
        !dayOfWeek ||
        !brightLevel ||
        brightLevel?.length > 50
      ) {
        return;
      }

      const data = {
        ...form.values,
        dayOfWeek: Number.parseInt(form.values.dayOfWeek),
        dimLevel: Number.parseInt(form.values.dimLevel),
        brightLevel: Number.parseInt(form.values.brightLevel),
        assetCode: id,
        id: selectedIdToDeleteOrEdit,
      };

      if (isEdit) {
        dispatch(updateDimmingProfile({ body: data })).then(() => {
          refetchDimmingProfile();
        });
      } else {
        dispatch(postDimmingProfile({ body: data })).then(() => {
          refetchDimmingProfile();
        });
      }
    }

    handleCloseModal();
  };

  //
  const editAction = (id: number) => {
    dispatch(getDaysOfWeek());

    setIsEdit(true);
    setIsModalOpen(true);
    setIsDetails(false);
    setIsDelete(false);

    dispatch(getDimmingProfileByCode({ dimmingProfileId: id }));

    setSelectedIdToDeleteOrEdit(id);
  };

  const handleAdd = () => {
    setInitialValues({
      profileName: "",
      startTime: "",
      endTime: "",
      zoneID: "",
      dimLevel: "",
      brightLevel: "",
      dayOfWeek: "",
    });

    setIsDetails(false);
    setIsModalOpen(true);
    setIsEdit(false);
    setIsDelete(false);
  };

  const handleRefresh = () => {
    setIsRefreshing(true);
    dispatch(
      sendGetCommandToDms({
        assetCode: id,
        module: Number(AssetCommandEnums.DimmingProfile),
      })
    )
      .then(() => {
        refetchDimmingProfile()
          .then(() => {
            setIsRefreshing(false);
          })
          .catch(() => {
            setIsRefreshing(false);
          });
      })
      .catch(() => {
        setIsRefreshing(false);
      });
  };

  const handleReset = () => {
    if (mfaInfo?.isDMSMfaEnabled) {
      setIsOtpModalOpen(true);
    } else {
      onSubmitMfaOtp("reset");
    }
  };

  const handleProfileEnableDisable = (isEnable: boolean) => {
    setIsEnableProfile(isEnable);

    const ids = selectedItems?.map((item: any) => item?.value);

    if (ids?.length <= 0) {
      return;
    }

    if (mfaInfo?.isDMSMfaEnabled) {
      setIsOtpModalOpen(true);
    } else {
      onSubmitMfaOtp("enableOrDisable", isEnable);
    }
  };

  const onSubmitMfaOtp = (currentFeature: string, isEnable?: boolean) => {
    switch (currentFeature) {
      case "reset":
        dispatch(resetDimmingProfile({ assetCode: id }));
        break;
      case "enableOrDisable":
        if (!isEnable) {
          const ids = selectedItems?.map((item: any) => item?.value);
          dispatch(
            enableOrDisableDimmingProfile({ body: ids, isEnable: isEnable })
          );
        } else {
          setIsRepeatActionModalOpen(true);
        }
        break;
      default:
        break;
    }

    dispatch(setOtpIsValidation(false));
    handleCloseModal();
  };

  const validationSchema = yup.object().shape({
    profileName: yup
      .string()
      .trim()
      .required("Profile Name is required")
      .max(50, "Profile Name must be at most 50 characters"),
    startTime: yup.string().required("Start Time is required"),
    endTime: yup.string().required("End Time is required"),
    zoneID: yup.string().required("Zone is required"),
    dimLevel: yup
      .string()
      .required("Dim Level is required")
      .max(50, "Dim Level must be at most 50 characters"),
    brightLevel: yup
      .string()
      .required("Bright Level is required")
      .max(50, "Bright Level must be at most 50 characters"),
    dayOfWeek: yup.string().required("Days Of Weeks is required"),
  });
  const repeatActionValidation = yup.object().shape({});

  const [columns, setColumns] = useState([
    {
      title: "Profile Name",
      label: "profileName",
      isSorted: true,
    },
    {
      title: "Start Time",
      label: "startTime",
    },
    {
      title: "Day Of Weeks",
      label: "dayOfWeek",
    },
    {
      title: "Group",
      label: "group",
    },
    {
      title: "Dim Level (%)",
      label: "dimLevel",
    },
    {
      title: "Bright Level (%)",
      label: "brightLevel",
    },
    {
      title: "Status",
      label: "status",
    },
  ]);

  const isOtpVerified = useSelector((state: any) => {
    return state.otp.isOtpVerified;
  });

  const onSubmitRepeatAction = () => {
    const form: any = repeatActionFormRef.current;

    if (form) {
      form.handleSubmit();

      setRepeatActionInitialValues({
        repeatAction: form.values.repeatAction,
      });

      const ids = selectedItems?.map((item: any) => item?.value);

      dispatch(
        enableOrDisableDimmingProfile({
          body: ids,
          isEnable: isEnableProfile,
          repeatAction: form.values.repeatAction,
        })
      );
      setIsRepeatActionModalOpen(false);
    }
  };

  const handleCloseOtpModal = () => {
    setIsOtpModalOpen(false);
  };

  const handleCloseRepeatActionModal = () => {
    setIsRepeatActionModalOpen(false);
  };

  const deleteAction = (dimmingProfileId: any) => {
    setIsDetails(false);
    setIsModalOpen(true);
    setIsEdit(false);
    setIsDelete(true);

    setSelectedIdToDeleteOrEdit(dimmingProfileId);
  };

  const handleDelete = () => {
    dispatch(
      deleteDimmingProfile({ dimmingProfileId: selectedIdToDeleteOrEdit })
    ).then(() => {
      refetchDimmingProfile();
      handleCloseModal();
    });
  };

  function isDisplayButton(data: any, label: any): boolean {
    if (data?.isBaseProfile) {
      return false;
    }
    return true;
  }

  const modalActionConfig = isDetails
    ? []
    : isDelete
      ? [
        {
          label: "Yes",
          event: handleDelete,
          variant: "primary",
        },
      ]
      : [
        {
          label: "Save",
          event: onSubmit,
          variant: "primary",
        },
      ];

  const mfaActionConfig: any = [
    {
      label: "Save",
      event: onSubmitMfaOtp,
      variant: "primary",
      disabled: !isOtpVerified,
    },
  ];

  const RepeatActionConfig: any = [
    {
      label: "Save",
      event: onSubmitRepeatAction,
      variant: "primary",
    },
  ];

  const actionConfig: any = [
    {
      label: "Edit",
      actionProperty: "id",
      event: editAction,
      variant: "secondary",
      className: "mx-2 my-1",
      icon: faPencilAlt,
      moduleName: "Dimming Profile",
      actionName: "Edit-Dimming Profile",
    },
    {
      label: "Delete",
      actionProperty: "id",
      event: deleteAction,
      isDisplay: isDisplayButton,
      variant: "danger",
      className: "mx-2 my-1",
      icon: faTrashAlt,
      moduleName: "Dimming Profile",
      actionName: "Delete-Dimming Profile",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Dimming Profile | Asset</title>
      </Helmet>
      <div>
        <div className="bg-card">
          {/* <div className="d-flex justify-content-end table-generic-action">
            <HasPermission
              moduleName="Dimming Profile"
              actionName="Add-Dimming Profile"
              isRoute={false}
            >
              <div>
                <B2Button
                  className=""
                  variant="default"
                  onClick={handleRefresh}
                >
                  <FontAwesomeIcon icon={faRotateRight} className="fs-7 me-2" />
                  Refresh
                </B2Button>
              </div>
            </HasPermission>
          </div>

          <div className="my-3">
            <CustomSpinnerComponent
              height={"300px"}
              width={"100%"}
              isLoading={!chartDataLoaded}
            >
              <CustomHighchartComponent
                xAxisCategories={null}
                xAxisMin={0}
                xAxisMax={23}
                SeriesType={"column"}
                multipleSeriesData={multipleSeriesData}
                seriesShowInLegend={true}
                xAxisTitleText={"Time (Hours)"}
                yAxisTitleText={"Level"}
                colors={["#3B1DCD", "#9d43bb"]}
                xAxisTimeFormatter={true}
              />
            </CustomSpinnerComponent>
          </div> */}

          <div className="my-3">
            <div className="d-flex justify-content-end table-generic-action">
              <HasPermission
                moduleName="Dimming Profile"
                actionName="Add-Dimming Profile"
                isRoute={false}
              >
                <div className="d-flex justify-end items-end">
                  <B2Button
                    className=""
                    variant="default"
                    onClick={handleReset}
                  >
                    <img
                      src={resetBtn}
                      alt="reset"
                      height={"20px"}
                      className="me-2"
                    />
                    Reset
                  </B2Button>

                  <B2Button variant="primary" onClick={handleAdd}>
                    Add Dimming Profile
                  </B2Button>
                </div>
              </HasPermission>
            </div>
            <div className="mt-3">
              <TableComponent
                tableHeaders={columns}
                data={dimmingProfiles?.data}
                totalNumberOfRecords={dimmingProfiles?.numberOfRecords}
                pageSize={pageSize}
                current={PageNumber}
                onChangePage={handleChangePage}
                onChangeSort={handleChangeSort}
                enableSelection={true}
                isLoadingData={isLoadingDimmingProfiles || isRefreshing}
                actionConfig={actionConfig}
                count={5}
                wrapperHeight="350px"
                moduleName="Dimming Profile"
                actionName="Edit-Dimming Profile"
              />
            </div>
          </div>

          <div className="my-3 d-flex justify-content-start align-items-center gap-3 table-generic-action ">
            <HasPermission
              moduleName="Dimming Profile"
              actionName="Enable-Dimming Profile"
              isRoute={false}
            >
              <B2Button
                className="d-flex justify-content-center align-items-center "
                variant="default"
                onClick={() => handleProfileEnableDisable(true)}
              >
                <img
                  src={circleCheck}
                  alt="enable"
                  height={"20px"}
                  className="me-2"
                />
                Enable Profile
              </B2Button>
            </HasPermission>

            <HasPermission
              moduleName="Dimming Profile"
              actionName="Disable-Dimming Profile"
              isRoute={false}
            >
              <B2Button
                className="d-flex justify-content-center align-items-center "
                variant="default"
                onClick={() => handleProfileEnableDisable(false)}
              >
                <img
                  src={circleCross}
                  alt="disable"
                  height={"20px"}
                  className="me-2"
                />
                Disable Profile
              </B2Button>
            </HasPermission>
          </div>
        </div>

        {/* modals */}

        {isModalOpen && (
          <ModalComponent
            showModal={isModalOpen}
            handleClose={handleCloseModal}
            headerTitle={
              isEdit
                ? "Edit Dimming Profile"
                : isDetails
                  ? "Dimming Profile Details"
                  : isDelete
                    ? "Delete Dimming Profile"
                    : "Add Dimming Profile"
            }
            actionConfig={modalActionConfig}
          >
            {isDelete ? (
              <h5 className="text-center">
                Are you sure to <b className="text-danger">Delete</b>?
              </h5>
            ) : (
              <FormBuilderComponent
                formRef={formRef}
                validation={validationSchema}
                initialValues={initialValues}
                formConfig={formConfig}
              />
            )}
          </ModalComponent>
        )}

        {isOTPModalOpen && (
          <ModalComponent
            showModal={isOTPModalOpen}
            handleClose={handleCloseOtpModal}
            actionConfig={mfaActionConfig}
            headerTitle={"Multi Factor Authentication"}
            isViewMode={false}
          >
            <MfaComponent />
          </ModalComponent>
        )}

        {isRepeatActionModalOpen && (
          <ModalComponent
            showModal={isRepeatActionModalOpen}
            handleClose={handleCloseRepeatActionModal}
            actionConfig={RepeatActionConfig}
            headerTitle={"Repeat Action"}
            isViewMode={false}
          >
            <FormBuilderComponent
              formRef={repeatActionFormRef}
              validation={repeatActionValidation}
              initialValues={repeatActionInitialValues}
              formConfig={repeatActionFormConfig}
            />
          </ModalComponent>
        )}
      </div>
    </>
  );
};

export default DimmingProfileComponent;
